import { Alert } from '@mui/material'
import React, { PropsWithChildren } from 'react'

interface ILinkComponentProps extends PropsWithChildren {
  severity?: 'info' | 'success' | 'warning' | 'error' | undefined
  setOpen?: () => void
  icon?: React.ReactNode
  variant?: 'filled' | 'outlined' | 'standard' | undefined
}

const defaultSettings: ILinkComponentProps = {
  severity: 'info',
  icon: false,
  variant: 'standard',
}

const AlertComponent: React.FC<ILinkComponentProps> = (props) => {
  const severity = props.severity ? props.severity : defaultSettings.severity
  const variant = props.variant ? props.variant : defaultSettings.variant
  const icon = props.icon ? props.icon : defaultSettings.icon

  return (
    <Alert
      icon={icon}
      style={{ whiteSpace: 'pre-line' }}
      severity={severity}
      variant={variant}
      onClose={() => props.setOpen && props.setOpen()}
      sx={{ mb: 2 }}
    >
      {props.children}
    </Alert>)
}

export default AlertComponent
